import React from 'react'
import PropTypes from 'prop-types'
import { Box, makeStyles } from '@material-ui/core'
import { isNumber } from 'lodash'
import Text from '../../../../../atoms/Text'
import NumberFormat from '../../../../../atoms/NumberFormat'
import ClientCardBalanceIndicator from '../ClientCardBalanceIndicator'
import { numeralByCase } from '../../../../../../utils'

const useStyles = makeStyles(() => ({
  container: {
    transition: 'all 0.2s linear 0s',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center'
  }
}))

const ClientBalance = ({ endingValue, balanceChangeStatus }) => {
  const classes = useStyles()

  return (
    <div className={classes.container}>
      <Box component='span' display='inline-flex' alignItems='center'>
        <Text
          text={isNumber(endingValue) ? (
            <NumberFormat title={numeralByCase(endingValue || 0)} number={endingValue || 0} format='$0,0a' />
          ) : ('--')}
        />
      </Box>
      <Box mr='0.5rem' />
      <ClientCardBalanceIndicator balanceChangeStatus={balanceChangeStatus} />
    </div>
  )
}

ClientBalance.propTypes = {
  endingValue: PropTypes.number,
  balanceChangeStatus: PropTypes.string
}

ClientBalance.defaultProps = {
  endingValue: undefined,
  balanceChangeStatus: undefined
}

export default ClientBalance
